import "./Skills.css"
import Skill from "./Skill"
import Organizer from "./Organizer"
import { useEffect, useState } from 'react';

function Skills() {

    const[sll, setSLL] = useState([]);
    const[slr, setSLR] = useState([]);
    const[slitems, setSlitems] = useState([]);
    const[original, setOriginal] = useState([]);

    useEffect(() => {
        let sl = require("./Resources/skills")
        let projects = require("./Resources/projects")
        let experiences = require("./Resources/experiences")
        for (let p = 0; p < projects.projects.length; p++) {
                let pr = projects.projects[p]
                for (let p1 = 0; p1 < pr.technologies.length; p1++) {
                    const sk = sl.skills.find(item => item.name === pr.technologies[p1])
                    if (sk && !sk.projects.includes(pr.name)) {
                        sk.projects.push(pr.name)
                    }
                }
            }

            for (let p = 0; p < experiences.experiences.length; p++) {
                let pr = experiences.experiences[p]
                for (let p1 = 0; p1 < pr.technologies.length; p1++) {
                    const sk = sl.skills.find(item => item.name === pr.technologies[p1])
                    if (sk && !sk.experiences.includes(pr.name)) {
                        sk.experiences.push(pr.name)
                    }
                }
            }
            setSlitems(sl.skills);
            setOriginal(sl.skills);
    }, []);

    useEffect(() => {
        if (slitems.length > 1) {
            if (slitems.length % 2 === 0) {
                setSLL(slitems.slice(0, Math.floor(slitems.length / 2)));
                setSLR(slitems.slice(Math.floor(slitems.length / 2)));
            } else {
                setSLL(slitems.slice(0, Math.floor(slitems.length / 2)+1));
                setSLR(slitems.slice(Math.floor(slitems.length / 2)+1));
                }
        } else {
                setSLL(slitems);
        }

    }, [slitems])

    function setItemsFunc(newArr) {
        setSlitems(newArr)
        if (newArr.length > 1) {
            if (newArr.length % 2 === 0) {
                setSLL(slitems.slice(0, Math.floor(slitems.length / 2)));
                setSLR(slitems.slice(Math.floor(slitems.length / 2)));
            } else {
                setSLL(slitems.slice(0, Math.floor(slitems.length / 2)+1));
                setSLR(slitems.slice(Math.floor(slitems.length / 2)+1));
            }
        } else {
            setSLL(slitems);
            setSLR([]);
        }
    }

    let filters = [{"name": "A-Z", "var": "name"}, {"name": "Type", "var": "type"}]
  return (
    <div className="Skills">

    {/*Sorting Menu - converts to dropdown*/}
    <h1>Skills</h1>

    <Organizer filters={filters} setFunc={setItemsFunc} arr={original}/>

    {/*List of skills you can expand*/}
    <div className="flex-container">
    <div className="leftSkillsPane">
        {sll.map((item) => (
        <div key={item.name}>
                <Skill name={item.name} type={item.type} classes={item.classes.join(", ")} projects={item.projects.join(", ")} experiences={item.experiences.join(", ")}/>
            </div>
        ))}
    </div>

    <div className="rightSkillsPane">
        {slr.map((item) => (
            <div key={item.name}>
                <Skill name={item.name} type={item.type} classes={item.classes.join(", ")} projects={item.projects.join(", ")} experiences={item.experiences.join(", ")}/>
            </div>
        ))}

    </div>
    </div>
    </div>
  );
}

export default Skills;